<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Redefinir senha</p>
    </header>
    <section class="modal-card-body">
      <div class="row">
        <div class="col-12">
          <app-input v-model="cpf" :errors="errors.cpf" label="CPF" v-mask="'###.###.###-##'"></app-input>
        </div>
        <div class="col-6">
          <app-input
            v-model="password"
            :errors="errors.password"
            label="Nova Senha"
            type="password"
          ></app-input>
        </div>
        <div class="col-6">
          <app-input
            v-model="password_confirmation"
            :errors="errors.password_confirmation"
            label="Confirmar Nova Senha"
            type="password"
          ></app-input>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button
        @click="resetPassword()"
        :disabled="$v.$invalid || isSaving"
        v-app-button
      >Atualizar senha</button>
    </footer>
  </div>
</template>

<script>
import ClientService from '@/services/client.service';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';

export default {
  name: 'app-modal',
  data: () => {
    return {
      isSaving: false,
      errors: {},
      cpf: null,
      password: null,
      password_confirmation: null,
    };
  },
  validations: {
    cpf: { required },
    password: { required, minLength: minLength(6) },
    password_confirmation: { sameAsPassword: sameAs('password') },
  },
  methods: {
    resetPassword() {
      const { cpf, password, password_confirmation } = this;

      this.isSaving = true;
      ClientService.resetPassword({
        cpf: cpf.replace(/\D/g, ''),
        password,
        password_confirmation,
      })
        .then(() => {
          this.toastify('Senha atualizada com sucesso!');
          this.$parent.close();
          this.$router.push('/');
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) {
            this.errors = errors;
          } else {
            this.toastify(
              message || 'Erro ao tentar atualizar senha.',
              'error'
            );
          }
        })
        .finally(() => (this.isSaving = false));
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-card {
  &-head {
    background: var(--color-secondary);

    p {
      color: #fff;
    }
  }

  &-body {
    h1 {
      font-family: var(--font-family-secondary);
      font-weight: 600;
      font-size: 2rem;
      color: var(--color-primary);
      text-align: center;
      margin-bottom: 8px;
    }

    p {
      font-size: 1.1rem;
      color: var(--text-color-medium);
      text-align: center;
      margin-bottom: 32px;
    }
  }
}
</style>
